module.exports = __webpack_public_path__ + "static/media/fondo_locucion.f2e0d5bb.jpg";